export default __webpack_public_path__ + "static/m-customer1-010a42d7c9aa57749ad0c35f3e880cf6.png";